
// import React, { useEffect, useState, useRef } from 'react'; // Added useRef
// import {
//   Box, Typography, Button, Dialog, DialogActions,
//   DialogContent, DialogTitle, TextField, IconButton, Select,
//   MenuItem, FormControl, InputLabel, Chip, FormHelperText,
//   Autocomplete
// } from '@mui/material';
// import { Delete, Edit, Add, Photo, Description, Person } from '@mui/icons-material';
// import TableComponent from '../../Components/TableComponent/TableComponent';
// import { SnackBarComponent } from '../../Components/snackBar/snackBar';
// import { API_BASE_URL } from '../../config';
// import { LoadingSpinner } from '../../Components/spinner/spinner';
// import api from '../../api/axiosInterceptor';
// import axios from 'axios';

// export const AdminPropertyComponent = () => {
//   const [rows, setRows] = useState([]);
//   const [feList, setFeList] = useState([]);
//   const [feLoading, setFeLoading] = useState(true);
//   const [loading, setLoading] = useState(true);
//   const [submitLoading, setSubmitLoading] = useState(false);
//   const [snackbarOpen, setSnackbarOpen] = useState(false);
//   const [snackbarMessage, setSnackbarMessage] = useState('');
//   const [snackbarSeverity, setSnackbarSeverity] = useState('info');

//   const [openFormDialog, setOpenFormDialog] = useState(false);
//   const [isEditMode, setIsEditMode] = useState(false);
//   const [selectedProperty, setSelectedProperty] = useState(null);

//   const [formData, setFormData] = useState({
//     fe: null,
//     name: '',
//     type: '',
//     latitude: '',
//     longitude: '',
//     address: '',
//     details: '',
//     contact: '',
//     status: ''
//   });

//   const [photos, setPhotos] = useState([]);
//   const [documents, setDocuments] = useState([]);
//   const [formErrors, setFormErrors] = useState({});

//   // Add refs for file inputs
//   const photoInputRef = useRef(null);
//   const documentInputRef = useRef(null);

//   const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
//   const [deleteProperty, setDeleteProperty] = useState(null);

//   const propertyTypes = [
//     '3(2)', '5(2)', 'valuation', 'auction', 'section8', 'section13'
//   ];

//   const statusOptions = [
//     'Active', 'Inactive', 'Pending', 'Archived', 'Sold', 'Auctioned', "In Progress", "Completed"
//   ];

//   const columns = [
//     { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 80 },
//     { 
//       id: 'fe_name', 
//       field: 'fe_name', 
//       headerName: 'FE Name', 
//       width: 180,
//       renderCell: (params) => params.value || 'N/A'
//     },
//     { id: 'name', field: 'name', headerName: 'Property Name', width: 200 },
//     { 
//       id: 'type', 
//       field: 'type', 
//       headerName: 'Type', 
//       width: 120,
//       renderCell: (params) => (
//         <Chip label={params.value} size="small" color="primary" variant="outlined" />
//       )
//     },
//     { 
//       id: 'status', 
//       field: 'status', 
//       headerName: 'Status', 
//       width: 120,
//       renderCell: (params) => (
//         <Chip 
//           label={params.value || 'None'} 
//           size="small" 
//           color={params.value === 'Active' ? 'success' : 
//                  params.value === 'Inactive' ? 'error' : 'default'}
//         />
//       )
//     },
//     { id: 'address', field: 'address', headerName: 'Address', width: 250 },
//     { 
//       id: 'coordinates', 
//       field: 'coordinates', 
//       headerName: 'Location', 
//       width: 150,
//       renderCell: (params) => `${params.value[0].toFixed(4)}, ${params.value[1].toFixed(4)}`
//     },
//     { 
//       id: 'images', 
//       field: 'images', 
//       headerName: 'Photos', 
//       width: 100,
//       renderCell: (params) => params.value?.length || 0
//     },
//     { 
//       id: 'documents', 
//       field: 'documents', 
//       headerName: 'Docs', 
//       width: 80,
//       renderCell: (params) => params.value?.length || 0
//     },
//     {
//       id: 'actions',
//       field: 'actions',
//       headerName: 'Actions',
//       width: 150,
//       renderCell: (params) => (
//         <>
//           <IconButton color="primary" onClick={() => handleEdit(params.row)}>
//             <Edit />
//           </IconButton>
//           <IconButton color="error" onClick={() => handleDeleteConfirmation(params.row)}>
//             <Delete />
//           </IconButton>
//         </>
//       ),
//     },
//   ];

//   useEffect(() => {
//     fetchFeList();
//   }, []);

//   useEffect(() => {
//     if (feList.length > 0) {
//       fetchProperties();
//     }
//   }, [feList]);

//   const fetchFeList = async () => {
//     setFeLoading(true);
//     try {
//       const response = await axios.get(`${API_BASE_URL}/home-notification/assignedfe/`);
//       setFeList(response.data);
//     } catch (error) {
//       console.error('Failed to fetch FE list:', error);
//       setSnackbarMessage('Failed to load FE list.');
//       setSnackbarSeverity('error');
//       setSnackbarOpen(true);
//     } finally {
//       setFeLoading(false);
//     }
//   };

//   const fetchProperties = () => {
//     setLoading(true);
//     axios.get(`${API_BASE_URL}/asset-mgmt/property-map/`)
//       .then(response => {
//         const apiData = response.data.map((item, index) => ({
//           id: item.id,
//           slNo: index + 1,
//           fe_name: item.fe?.name || item.fe?.name_of_fe || 'N/A',
//           fe: item.fe,
//           name: item.name || '',
//           type: item.type || '',
//           status: item.status || '',
//           coordinates: [parseFloat(item.latitude) || 0, parseFloat(item.longitude) || 0],
//           address: item.address || '',
//           details: item.details || '',
//           contact: item.contact || '',
//           images: item.photos || [],
//           documents: item.documents || []
//         }));
//         setRows(apiData);
//         setLoading(false);
//       })
//       .catch(error => {
//         console.error('Failed to fetch properties:', error);
//         setSnackbarMessage('Failed to load properties.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//         setLoading(false);
//       });
//   };

//   const handleSnackbarClose = () => {
//     setSnackbarOpen(false);
//   };

//   const handleAddProperty = () => {
//     setIsEditMode(false);
//     setFormData({
//       fe: null,
//       name: '',
//       type: '',
//       latitude: '',
//       longitude: '',
//       address: '',
//       details: '',
//       contact: '',
//       status: ''
//     });
//     setPhotos([]);
//     setDocuments([]);
//     setFormErrors({});
//     setSelectedProperty(null);
    
//     // Reset file inputs
//     if (photoInputRef.current) photoInputRef.current.value = '';
//     if (documentInputRef.current) documentInputRef.current.value = '';
    
//     setOpenFormDialog(true);
//   };

//   const handleEdit = (property) => {
//     setIsEditMode(true);
//     setSelectedProperty(property);
    
//     const selectedFe = feList.find(fe => fe.id === property.fe?.id) || null;
    
//     setFormData({
//       fe: selectedFe,
//       name: property.name || '',
//       type: property.type,
//       latitude: property.coordinates[0].toString(),
//       longitude: property.coordinates[1].toString(),
//       address: property.address,
//       details: property.details,
//       contact: property.contact,
//       status: property.status || ''
//     });
//     setPhotos([]);
//     setDocuments([]);
//     setFormErrors({});
    
//     // Reset file inputs
//     if (photoInputRef.current) photoInputRef.current.value = '';
//     if (documentInputRef.current) documentInputRef.current.value = '';
    
//     setOpenFormDialog(true);
//   };

//   const handleDeleteConfirmation = (property) => {
//     setDeleteProperty(property);
//     setDeleteDialogOpen(true);
//   };

//   const handleDelete = () => {
//     api.delete(`${API_BASE_URL}/asset-mgmt/property-map/${deleteProperty.id}/`)
//       .then(() => {
//         setSnackbarMessage('Property deleted successfully.');
//         setSnackbarSeverity('success');
//         setSnackbarOpen(true);
//         fetchProperties();
//       })
//       .catch(error => {
//         console.error('Delete failed:', error);
//         setSnackbarMessage('Failed to delete property.');
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//       })
//       .finally(() => {
//         setDeleteDialogOpen(false);
//         setDeleteProperty(null);
//       });
//   };

//   const validateForm = () => {
//     const errors = {};
//     if (!formData.fe) errors.fe = 'FE is required';
//     if (!formData.name?.trim()) errors.name = 'Property name is required';
//     if (!formData.type) errors.type = 'Type is required';
//     if (!formData.latitude || isNaN(formData.latitude) || formData.latitude < -90 || formData.latitude > 90) {
//       errors.latitude = 'Valid latitude (-90 to 90) is required';
//     }
//     if (!formData.longitude || isNaN(formData.longitude) || formData.longitude < -180 || formData.longitude > 180) {
//       errors.longitude = 'Valid longitude (-180 to 180) is required';
//     }
//     if (!formData.address?.trim()) errors.address = 'Address is required';
//     // if (photos.length === 0 && !isEditMode) errors.photos = 'At least one photo is required';
//     if (photos.some(file => file.size > 5 * 1024 * 1024)) errors.photos = 'Each photo must be < 5MB';

//     setFormErrors(errors);
//     return Object.keys(errors).length === 0;
//   };

//   const handlePhotoChange = (e) => {
//     const files = Array.from(e.target.files);
//     if (files.length > 10) {
//       setFormErrors(prev => ({ ...prev, photos: 'Maximum 10 photos allowed' }));
//       return;
//     }
//     if (files.some(file => file.size > 5 * 1024 * 1024)) {
//       setFormErrors(prev => ({ ...prev, photos: 'Each photo must be < 5MB' }));
//       return;
//     }
//     setPhotos(files);
//     setFormErrors(prev => ({ ...prev, photos: null }));
//   };

//   const handleDocumentChange = (e) => {
//     const files = Array.from(e.target.files);
//     if (files.length > 5) {
//       setFormErrors(prev => ({ ...prev, documents: 'Maximum 5 documents allowed' }));
//       return;
//     }
//     if (files.some(file => file.size > 5 * 1024 * 1024)) {
//       setFormErrors(prev => ({ ...prev, documents: 'Each document must be < 5MB' }));
//       return;
//     }
//     setDocuments(files);
//     setFormErrors(prev => ({ ...prev, documents: null }));
//   };

//   const handleFormSubmit = () => {
//     if (!validateForm()) return;

//     setSubmitLoading(true);

//     const form = new FormData();
//     form.append('fe', formData.fe.id);
//     form.append('name', formData.name);
//     form.append('type', formData.type);
//     form.append('latitude', formData.latitude);
//     form.append('longitude', formData.longitude);
//     form.append('address', formData.address);
//     form.append('details', formData.details);
//     form.append('contact', formData.contact);
//     form.append('status', formData.status);

//     // ✅ Append all photos with same key 'photos'
//     photos.forEach((file) => {
//       form.append('photos', file);
//     });

//     // ✅ Append all documents with same key 'documents'
//     documents.forEach((file) => {
//       form.append('documents', file);
//     });

//     const url = isEditMode 
//       ? `${API_BASE_URL}/asset-mgmt/property-map/${selectedProperty.id}/`
//       : `${API_BASE_URL}/asset-mgmt/property-map/`;

//     const method = isEditMode ? api.patch : api.post;

//     method(url, form, { headers: { 'Content-Type': 'multipart/form-data' } })
//       .then(() => {
//         setSnackbarMessage(`Property ${isEditMode ? 'updated' : 'added'} successfully.`);
//         setSnackbarSeverity('success');
//         setSnackbarOpen(true);
//         fetchProperties();
//       })
//       .catch(error => {
//         console.error('Submit failed:', error);
//         setSnackbarMessage(`Failed to ${isEditMode ? 'update' : 'add'} property.`);
//         setSnackbarSeverity('error');
//         setSnackbarOpen(true);
//       })
//       .finally(() => {
//         setSubmitLoading(false);
//         setOpenFormDialog(false);
//       });
//   };

//   if (loading && rows.length === 0) {
//     return <LoadingSpinner size={30} />;
//   }

//   return (
//     <Box sx={{ width: '100%', mt: 8, mb: 1, borderRadius: 2, boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)', backgroundColor: '#fff' }}>
//       <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: 'rgba(195, 234, 203, 0.1)', p: 2 }}>
//         <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
//           Admin Properties
//         </Typography>
//         <Button variant="contained" color="primary" startIcon={<Add />} onClick={handleAddProperty}>
//           Add Property
//         </Button>
//       </Box>

//       <TableComponent
//         columns={columns}
//         rows={rows}
//         manageColumnStatus
//         enableSort={true}
//         sx={{
//           '.MuiDataGrid-columnHeaders': {
//             backgroundColor: '#1976d2',
//             color: '#fff',
//             fontWeight: 'bold',
//           },
//         }}
//       />

//       {/* Add/Edit Form Dialog */}
//       <Dialog open={openFormDialog} onClose={() => setOpenFormDialog(false)} maxWidth="md" fullWidth>
//         <DialogTitle>{isEditMode ? 'Edit Property' : 'Add Property'}</DialogTitle>
//         <DialogContent>
//           <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
//             {/* Show existing files when editing */}
//             {isEditMode && selectedProperty && (
//               <>
//                 {/* Existing Photos */}
//                 {selectedProperty.images?.length > 0 && (
//                   <Box>
//                     <Typography variant="subtitle2" sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
//                       <Photo sx={{ mr: 1 }} /> Existing Photos
//                     </Typography>
//                     <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
//                       {selectedProperty.images.map((url, i) => (
//                         <Chip 
//                           key={i}
//                           label={`Photo ${i + 1}`}
//                           size="small"
//                           color="secondary"
//                           onClick={() => window.open(url, '_blank')}
//                           sx={{ cursor: 'pointer' }}
//                         />
//                       ))}
//                     </Box>
//                   </Box>
//                 )}

//                 {/* Existing Documents */}
//                 {selectedProperty.documents?.length > 0 && (
//                   <Box>
//                     <Typography variant="subtitle2" sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
//                       <Description sx={{ mr: 1 }} /> Existing Documents
//                     </Typography>
//                     <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
//                       {selectedProperty.documents.map((url, i) => (
//                         <Chip 
//                           key={i}
//                           label={`Doc ${i + 1}`}
//                           size="small"
//                           color="info"
//                           onClick={() => window.open(url, '_blank')}
//                           sx={{ cursor: 'pointer' }}
//                         />
//                       ))}
//                     </Box>
//                   </Box>
//                 )}
//               </>
//             )}

//             <Autocomplete
//               options={feList}
//               getOptionLabel={(option) => option.name || option.name_of_fe || ''}
//               loading={feLoading}
//               value={formData.fe}
//               onChange={(event, newValue) => setFormData({ ...formData, fe: newValue })}
//               isOptionEqualToValue={(option, value) => option.id === value?.id}
//               renderInput={(params) => (
//                 <TextField
//                   {...params}
//                   label="Assigned FE *"
//                   margin="dense"
//                   error={!!formErrors.fe}
//                   helperText={formErrors.fe}
//                   InputProps={{
//                     ...params.InputProps,
//                     endAdornment: (
//                       <>
//                         {feLoading ? <LoadingSpinner size={20} /> : null}
//                         {params.InputProps.endAdornment}
//                       </>
//                     ),
//                   }}
//                 />
//               )}
//             />

//             <TextField
//               margin="dense"
//               label="Property Name *"
//               fullWidth
//               value={formData.name}
//               error={!!formErrors.name}
//               helperText={formErrors.name}
//               onChange={(e) => setFormData({ ...formData, name: e.target.value })}
//             />

//             <FormControl fullWidth margin="dense">
//               <InputLabel>Status</InputLabel>
//               <Select
//                 value={formData.status || ''}
//                 label="Status"
//                 onChange={(e) => setFormData({ ...formData, status: e.target.value })}
//               >
//                 {statusOptions.map((status) => (
//                   <MenuItem key={status} value={status}>
//                     {status || 'None'}
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>

//             <FormControl fullWidth error={!!formErrors.type} margin="dense">
//               <InputLabel>Type *</InputLabel>
//               <Select
//                 value={formData.type}
//                 label="Type"
//                 onChange={(e) => setFormData({ ...formData, type: e.target.value })}
//               >
//                 {propertyTypes.map((type) => (
//                   <MenuItem key={type} value={type}>{type}</MenuItem>
//                 ))}
//               </Select>
//               <FormHelperText>{formErrors.type}</FormHelperText>
//             </FormControl>

//             <Box sx={{ display: 'flex', gap: 2 }}>
//               <TextField
//                 margin="dense"
//                 label="Latitude *"
//                 fullWidth
//                 value={formData.latitude}
//                 error={!!formErrors.latitude}
//                 helperText={formErrors.latitude}
//                 onChange={(e) => setFormData({ ...formData, latitude: e.target.value })}
//               />
//               <TextField
//                 margin="dense"
//                 label="Longitude *"
//                 fullWidth
//                 value={formData.longitude}
//                 error={!!formErrors.longitude}
//                 helperText={formErrors.longitude}
//                 onChange={(e) => setFormData({ ...formData, longitude: e.target.value })}
//               />
//             </Box>

//             <TextField
//               margin="dense"
//               label="Address *"
//               fullWidth
//               multiline
//               rows={2}
//               value={formData.address}
//               error={!!formErrors.address}
//               helperText={formErrors.address}
//               onChange={(e) => setFormData({ ...formData, address: e.target.value })}
//             />

//             <TextField
//               margin="dense"
//               label="Details"
//               fullWidth
//               multiline
//               rows={3}
//               value={formData.details}
//               onChange={(e) => setFormData({ ...formData, details: e.target.value })}
//             />

//             <TextField
//               margin="dense"
//               label="Contact"
//               fullWidth
//               value={formData.contact}
//               onChange={(e) => setFormData({ ...formData, contact: e.target.value })}
//             />

//             {/* Photos Upload */}
//             <Box>
//               <Typography variant="subtitle2" sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
//                 <Photo sx={{ mr: 1 }} /> 
//                 {isEditMode ? 'Add New Photos' : 'Photos'} (Max 10, 5MB each)
//                 {isEditMode && <Typography variant="caption" sx={{ ml: 2, color: 'text.secondary' }}>
//                   (Will be added to existing photos)
//                 </Typography>}
//               </Typography>
//               <input
//                 accept="image/*"
//                 style={{ display: 'block', marginTop: '8px' }}
//                 id="photos-upload"
//                 type="file"
//                 multiple
//                 ref={photoInputRef}
//                 onChange={handlePhotoChange}
//               />
//               <Typography variant="caption" sx={{ display: 'block', mt: 0.5, color: 'text.secondary' }}>
//                 Hold Ctrl (Cmd on Mac) to select multiple files
//               </Typography>
//               {formErrors.photos && (
//                 <FormHelperText error>{formErrors.photos}</FormHelperText>
//               )}
//               {photos.length > 0 && (
//                 <Box sx={{ mt: 1 }}>
//                   {photos.map((file, i) => (
//                     <Chip 
//                       key={i} 
//                       label={file.name} 
//                       size="small" 
//                       color="success" 
//                       sx={{ mr: 1, mb: 1 }} 
//                       onDelete={() => {
//                         const newPhotos = [...photos];
//                         newPhotos.splice(i, 1);
//                         setPhotos(newPhotos);
//                       }}
//                     />
//                   ))}
//                 </Box>
//               )}
//             </Box>

//             {/* Documents Upload */}
//             <Box>
//               <Typography variant="subtitle2" sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
//                 <Description sx={{ mr: 1 }} /> 
//                 {isEditMode ? 'Add New Documents' : 'Documents'} (Max 5, 5MB each)
//                 {isEditMode && <Typography variant="caption" sx={{ ml: 2, color: 'text.secondary' }}>
//                   (Will be added to existing documents)
//                 </Typography>}
//               </Typography>
//               <input
//                 accept=".pdf,.doc,.docx,.xls,.xlsx"
//                 style={{ display: 'block', marginTop: '8px' }}
//                 id="documents-upload"
//                 type="file"
//                 multiple
//                 ref={documentInputRef}
//                 onChange={handleDocumentChange}
//               />
//               <Typography variant="caption" sx={{ display: 'block', mt: 0.5, color: 'text.secondary' }}>
//                 Hold Ctrl (Cmd on Mac) to select multiple files
//               </Typography>
//               {formErrors.documents && (
//                 <FormHelperText error>{formErrors.documents}</FormHelperText>
//               )}
//               {documents.length > 0 && (
//                 <Box sx={{ mt: 1 }}>
//                   {documents.map((file, i) => (
//                     <Chip 
//                       key={i} 
//                       label={file.name} 
//                       size="small" 
//                       color="info" 
//                       sx={{ mr: 1, mb: 1 }} 
//                       onDelete={() => {
//                         const newDocs = [...documents];
//                         newDocs.splice(i, 1);
//                         setDocuments(newDocs);
//                       }}
//                     />
//                   ))}
//                 </Box>
//               )}
//             </Box>
//           </Box>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setOpenFormDialog(false)} disabled={submitLoading}>
//             Cancel
//           </Button>
//           <Button onClick={handleFormSubmit} variant="contained" color="primary" disabled={submitLoading}>
//             {submitLoading ? <LoadingSpinner size={20} /> : (isEditMode ? 'Update' : 'Add')}
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Delete Confirmation Dialog */}
//       <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
//         <DialogTitle>Confirm Delete</DialogTitle>
//         <DialogContent>
//           Are you sure you want to delete "{deleteProperty?.name}" ({deleteProperty?.status})?
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setDeleteDialogOpen(false)} disabled={submitLoading}>
//             Cancel
//           </Button>
//           <Button onClick={handleDelete} variant="contained" color="error">
//             Delete
//           </Button>
//         </DialogActions>
//       </Dialog>

//       <SnackBarComponent
//         open={snackbarOpen}
//         message={snackbarMessage}
//         severity={snackbarSeverity}
//         onClose={handleSnackbarClose}
//       />
//     </Box>
//   );
// };

// export default AdminPropertyComponent;



import React, { useEffect, useState, useRef } from 'react'; // Added useRef
import {
  Box, Typography, Button, Dialog, DialogActions,
  DialogContent, DialogTitle, TextField, IconButton, Select,
  MenuItem, FormControl, InputLabel, Chip, FormHelperText,
  Autocomplete, ToggleButton, ToggleButtonGroup
} from '@mui/material';
import { Delete, Edit, Add, Photo, Description, Person, FilterList } from '@mui/icons-material';
import TableComponent from '../../Components/TableComponent/TableComponent';
import { SnackBarComponent } from '../../Components/snackBar/snackBar';
import { API_BASE_URL } from '../../config';
import { LoadingSpinner } from '../../Components/spinner/spinner';
import api from '../../api/axiosInterceptor';
import axios from 'axios';

export const AdminPropertyComponent = () => {
  const [rows, setRows] = useState([]);
  const [feList, setFeList] = useState([]);
  const [feLoading, setFeLoading] = useState(true);
  const [loading, setLoading] = useState(true);
  const [submitLoading, setSubmitLoading] = useState(false);
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState('info');

  const [openFormDialog, setOpenFormDialog] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [selectedProperty, setSelectedProperty] = useState(null);

  // Add filter state
  const [showAllProperties, setShowAllProperties] = useState(false);

  const [formData, setFormData] = useState({
    fe: null,
    name: '',
    type: '',
    latitude: '',
    longitude: '',
    address: '',
    details: '',
    contact: '',
    status: ''
  });

  const [photos, setPhotos] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [formErrors, setFormErrors] = useState({});

  // Add refs for file inputs
  const photoInputRef = useRef(null);
  const documentInputRef = useRef(null);

  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [deleteProperty, setDeleteProperty] = useState(null);

  const propertyTypes = [
    '3(2)', '5(2)', 'valuation', 'auction', 'section8', 'section13'
  ];

  const statusOptions = [
    'Active', 'Inactive', 'Pending', 'Archived', 'Sold', 'Auctioned', "In Progress", "Completed"
  ];

  const columns = [
    { id: 'slNo', field: 'slNo', headerName: 'Sl No.', width: 80 },
    { 
      id: 'fe_name', 
      field: 'fe_name', 
      headerName: 'FE Name', 
      width: 180,
      renderCell: (params) => params.value || 'N/A'
    },
    { id: 'name', field: 'name', headerName: 'Property Name', width: 200 },
    { 
      id: 'type', 
      field: 'type', 
      headerName: 'Type', 
      width: 120,
      renderCell: (params) => (
        <Chip label={params.value} size="small" color="primary" variant="outlined" />
      )
    },
    { 
      id: 'status', 
      field: 'status', 
      headerName: 'Status', 
      width: 120,
      renderCell: (params) => (
        <Chip 
          label={params.value || 'None'} 
          size="small" 
          color={params.value === 'Active' ? 'success' : 
                 params.value === 'Inactive' ? 'error' : 
                 params.value === 'Pending' ? 'warning' :
                 params.value === 'Archived' ? 'default' :
                 params.value === 'Sold' ? 'secondary' :
                 'primary'}
        />
      )
    },
    { id: 'address', field: 'address', headerName: 'Address', width: 250 },
    { 
      id: 'coordinates', 
      field: 'coordinates', 
      headerName: 'Location', 
      width: 150,
      renderCell: (params) => `${params.value[0].toFixed(4)}, ${params.value[1].toFixed(4)}`
    },
    { 
      id: 'images', 
      field: 'images', 
      headerName: 'Photos', 
      width: 100,
      renderCell: (params) => params.value?.length || 0
    },
    { 
      id: 'documents', 
      field: 'documents', 
      headerName: 'Docs', 
      width: 80,
      renderCell: (params) => params.value?.length || 0
    },
    {
      id: 'actions',
      field: 'actions',
      headerName: 'Actions',
      width: 150,
      renderCell: (params) => (
        <>
          <IconButton color="primary" onClick={() => handleEdit(params.row)}>
            <Edit />
          </IconButton>
          <IconButton color="error" onClick={() => handleDeleteConfirmation(params.row)}>
            <Delete />
          </IconButton>
        </>
      ),
    },
  ];

  useEffect(() => {
    fetchFeList();
  }, []);

  useEffect(() => {
    if (feList.length > 0) {
      fetchProperties();
    }
  }, [feList, showAllProperties]); // Added showAllProperties as dependency

  const fetchFeList = async () => {
    setFeLoading(true);
    try {
      const response = await axios.get(`${API_BASE_URL}/home-notification/assignedfe/`);
      setFeList(response.data);
    } catch (error) {
      console.error('Failed to fetch FE list:', error);
      setSnackbarMessage('Failed to load FE list.');
      setSnackbarSeverity('error');
      setSnackbarOpen(true);
    } finally {
      setFeLoading(false);
    }
  };

  const fetchProperties = () => {
    setLoading(true);
    
    // Build query parameters
    const params = {};
    if (showAllProperties) {
      params.show_all = 'true';
    }
    
    axios.get(`${API_BASE_URL}/asset-mgmt/property-map/`, { params })
      .then(response => {
        const apiData = response.data.map((item, index) => ({
          id: item.id,
          slNo: index + 1,
          fe_name: item.fe?.name || item.fe?.name_of_fe || 'N/A',
          fe: item.fe,
          name: item.name || '',
          type: item.type || '',
          status: item.status || '',
          coordinates: [parseFloat(item.latitude) || 0, parseFloat(item.longitude) || 0],
          address: item.address || '',
          details: item.details || '',
          contact: item.contact || '',
          images: item.photos || [],
          documents: item.documents || []
        }));
        setRows(apiData);
        setLoading(false);
      })
      .catch(error => {
        console.error('Failed to fetch properties:', error);
        setSnackbarMessage('Failed to load properties.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
        setLoading(false);
      });
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  const handleAddProperty = () => {
    setIsEditMode(false);
    setFormData({
      fe: null,
      name: '',
      type: '',
      latitude: '',
      longitude: '',
      address: '',
      details: '',
      contact: '',
      status: ''
    });
    setPhotos([]);
    setDocuments([]);
    setFormErrors({});
    setSelectedProperty(null);
    
    // Reset file inputs
    if (photoInputRef.current) photoInputRef.current.value = '';
    if (documentInputRef.current) documentInputRef.current.value = '';
    
    setOpenFormDialog(true);
  };

  const handleEdit = (property) => {
    setIsEditMode(true);
    setSelectedProperty(property);
    
    const selectedFe = feList.find(fe => fe.id === property.fe?.id) || null;
    
    setFormData({
      fe: selectedFe,
      name: property.name || '',
      type: property.type,
      latitude: property.coordinates[0].toString(),
      longitude: property.coordinates[1].toString(),
      address: property.address,
      details: property.details,
      contact: property.contact,
      status: property.status || ''
    });
    setPhotos([]);
    setDocuments([]);
    setFormErrors({});
    
    // Reset file inputs
    if (photoInputRef.current) photoInputRef.current.value = '';
    if (documentInputRef.current) documentInputRef.current.value = '';
    
    setOpenFormDialog(true);
  };

  const handleDeleteConfirmation = (property) => {
    setDeleteProperty(property);
    setDeleteDialogOpen(true);
  };

  const handleDelete = () => {
    api.delete(`/asset-mgmt/property-map/${deleteProperty.id}/`)
      .then(() => {
        setSnackbarMessage('Property deleted successfully.');
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        fetchProperties();
      })
      .catch(error => {
        console.error('Delete failed:', error);
        setSnackbarMessage('Failed to delete property.');
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      })
      .finally(() => {
        setDeleteDialogOpen(false);
        setDeleteProperty(null);
      });
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.fe) errors.fe = 'FE is required';
    if (!formData.name?.trim()) errors.name = 'Property name is required';
    if (!formData.type) errors.type = 'Type is required';
    if (!formData.latitude || isNaN(formData.latitude) || formData.latitude < -90 || formData.latitude > 90) {
      errors.latitude = 'Valid latitude (-90 to 90) is required';
    }
    if (!formData.longitude || isNaN(formData.longitude) || formData.longitude < -180 || formData.longitude > 180) {
      errors.longitude = 'Valid longitude (-180 to 180) is required';
    }
    if (!formData.address?.trim()) errors.address = 'Address is required';
    // if (photos.length === 0 && !isEditMode) errors.photos = 'At least one photo is required';
    if (photos.some(file => file.size > 5 * 1024 * 1024)) errors.photos = 'Each photo must be < 5MB';

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handlePhotoChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 10) {
      setFormErrors(prev => ({ ...prev, photos: 'Maximum 10 photos allowed' }));
      return;
    }
    if (files.some(file => file.size > 5 * 1024 * 1024)) {
      setFormErrors(prev => ({ ...prev, photos: 'Each photo must be < 5MB' }));
      return;
    }
    setPhotos(files);
    setFormErrors(prev => ({ ...prev, photos: null }));
  };

  const handleDocumentChange = (e) => {
    const files = Array.from(e.target.files);
    if (files.length > 5) {
      setFormErrors(prev => ({ ...prev, documents: 'Maximum 5 documents allowed' }));
      return;
    }
    if (files.some(file => file.size > 5 * 1024 * 1024)) {
      setFormErrors(prev => ({ ...prev, documents: 'Each document must be < 5MB' }));
      return;
    }
    setDocuments(files);
    setFormErrors(prev => ({ ...prev, documents: null }));
  };

  const handleFormSubmit = () => {
    if (!validateForm()) return;

    setSubmitLoading(true);

    const form = new FormData();
    form.append('fe', formData.fe.id);
    form.append('name', formData.name);
    form.append('type', formData.type);
    form.append('latitude', formData.latitude);
    form.append('longitude', formData.longitude);
    form.append('address', formData.address);
    form.append('details', formData.details);
    form.append('contact', formData.contact);
    form.append('status', formData.status);

    // ✅ Append all photos with same key 'photos'
    photos.forEach((file) => {
      form.append('photos', file);
    });

    // ✅ Append all documents with same key 'documents'
    documents.forEach((file) => {
      form.append('documents', file);
    });

    const url = isEditMode 
      ? `/asset-mgmt/property-map/${selectedProperty.id}/`
      : `/asset-mgmt/property-map/`;

    const method = isEditMode ? api.patch : api.post;

    method(url, form, { headers: { 'Content-Type': 'multipart/form-data' } })
      .then(() => {
        setSnackbarMessage(`Property ${isEditMode ? 'updated' : 'added'} successfully.`);
        setSnackbarSeverity('success');
        setSnackbarOpen(true);
        fetchProperties();
      })
      .catch(error => {
        console.error('Submit failed:', error);
        setSnackbarMessage(`Failed to ${isEditMode ? 'update' : 'add'} property.`);
        setSnackbarSeverity('error');
        setSnackbarOpen(true);
      })
      .finally(() => {
        setSubmitLoading(false);
        setOpenFormDialog(false);
      });
  };

  const handleFilterChange = (event, newFilter) => {
    if (newFilter !== null) {
      setShowAllProperties(newFilter === 'all');
    }
  };

  if (loading && rows.length === 0) {
    return <LoadingSpinner size={30} />;
  }

  return (
    <Box sx={{ width: '100%', mt: 8, mb: 1, borderRadius: 2, boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)', backgroundColor: '#fff' }}>
      <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', backgroundColor: 'rgba(195, 234, 203, 0.1)', p: 2 }}>
        <Typography variant="h4" component="h1" sx={{ fontWeight: 'bold' }}>
          Admin Properties
        </Typography>
        <Button variant="contained" color="primary" startIcon={<Add />} onClick={handleAddProperty}>
          Add Property
        </Button>
      </Box>

      {/* Filter Section */}
      <Box sx={{ p: 2, borderBottom: '1px solid #e0e0e0' }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
          <FilterList color="action" />
          <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
            Filter Properties:
          </Typography>
          <ToggleButtonGroup
            value={showAllProperties ? 'all' : 'active'}
            exclusive
            onChange={handleFilterChange}
            size="small"
          >
            <ToggleButton value="active" aria-label="show active only">
              <Typography variant="body2" sx={{ fontWeight: showAllProperties ? 'normal' : 'bold' }}>
                Active Properties Only
              </Typography>
            </ToggleButton>
            <ToggleButton value="all" aria-label="show all properties">
              <Typography variant="body2" sx={{ fontWeight: showAllProperties ? 'bold' : 'normal' }}>
                All Properties (Including Inactive)
              </Typography>
            </ToggleButton>
          </ToggleButtonGroup>
          
          {/* Status Statistics */}
          {/* <Box sx={{ display: 'flex', gap: 1, ml: 'auto' }}>
            <Chip 
              label={`Total: ${rows.length}`} 
              size="small" 
              color="primary" 
              variant="outlined"
            />
            <Chip 
              label={`Active: ${rows.filter(r => r.status === 'Active').length}`} 
              size="small" 
              color="success" 
              variant="outlined"
            />
            <Chip 
              label={`Inactive: ${rows.filter(r => r.status === 'Inactive').length}`} 
              size="small" 
              color="error" 
              variant="outlined"
            />
          </Box> */}
        </Box>
      </Box>

      <TableComponent
        columns={columns}
        rows={rows}
        manageColumnStatus
        enableSort={true}
        sx={{
          '.MuiDataGrid-columnHeaders': {
            backgroundColor: '#1976d2',
            color: '#fff',
            fontWeight: 'bold',
          },
        }}
      />

      {/* Add/Edit Form Dialog */}
      <Dialog open={openFormDialog} onClose={() => setOpenFormDialog(false)} maxWidth="md" fullWidth>
        <DialogTitle>{isEditMode ? 'Edit Property' : 'Add Property'}</DialogTitle>
        <DialogContent>
          <Box sx={{ mt: 2, display: 'flex', flexDirection: 'column', gap: 2 }}>
            {/* Show existing files when editing */}
            {isEditMode && selectedProperty && (
              <>
                {/* Existing Photos */}
                {selectedProperty.images?.length > 0 && (
                  <Box>
                    <Typography variant="subtitle2" sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                      <Photo sx={{ mr: 1 }} /> Existing Photos
                    </Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
                      {selectedProperty.images.map((url, i) => (
                        <Chip 
                          key={i}
                          label={`Photo ${i + 1}`}
                          size="small"
                          color="secondary"
                          onClick={() => window.open(url, '_blank')}
                          sx={{ cursor: 'pointer' }}
                        />
                      ))}
                    </Box>
                  </Box>
                )}

                {/* Existing Documents */}
                {selectedProperty.documents?.length > 0 && (
                  <Box>
                    <Typography variant="subtitle2" sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                      <Description sx={{ mr: 1 }} /> Existing Documents
                    </Typography>
                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 2 }}>
                      {selectedProperty.documents.map((url, i) => (
                        <Chip 
                          key={i}
                          label={`Doc ${i + 1}`}
                          size="small"
                          color="info"
                          onClick={() => window.open(url, '_blank')}
                          sx={{ cursor: 'pointer' }}
                        />
                      ))}
                    </Box>
                  </Box>
                )}
              </>
            )}

            <Autocomplete
              options={feList}
              getOptionLabel={(option) => option.name || option.name_of_fe || ''}
              loading={feLoading}
              value={formData.fe}
              onChange={(event, newValue) => setFormData({ ...formData, fe: newValue })}
              isOptionEqualToValue={(option, value) => option.id === value?.id}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Assigned FE *"
                  margin="dense"
                  error={!!formErrors.fe}
                  helperText={formErrors.fe}
                  InputProps={{
                    ...params.InputProps,
                    endAdornment: (
                      <>
                        {feLoading ? <LoadingSpinner size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </>
                    ),
                  }}
                />
              )}
            />

            <TextField
              margin="dense"
              label="Property Name *"
              fullWidth
              value={formData.name}
              error={!!formErrors.name}
              helperText={formErrors.name}
              onChange={(e) => setFormData({ ...formData, name: e.target.value })}
            />

            <FormControl fullWidth margin="dense">
              <InputLabel>Status</InputLabel>
              <Select
                value={formData.status || ''}
                label="Status"
                onChange={(e) => setFormData({ ...formData, status: e.target.value })}
              >
                {statusOptions.map((status) => (
                  <MenuItem key={status} value={status}>
                    {status || 'None'}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>

            <FormControl fullWidth error={!!formErrors.type} margin="dense">
              <InputLabel>Type *</InputLabel>
              <Select
                value={formData.type}
                label="Type"
                onChange={(e) => setFormData({ ...formData, type: e.target.value })}
              >
                {propertyTypes.map((type) => (
                  <MenuItem key={type} value={type}>{type}</MenuItem>
                ))}
              </Select>
              <FormHelperText>{formErrors.type}</FormHelperText>
            </FormControl>

            <Box sx={{ display: 'flex', gap: 2 }}>
              <TextField
                margin="dense"
                label="Latitude *"
                fullWidth
                value={formData.latitude}
                error={!!formErrors.latitude}
                helperText={formErrors.latitude}
                onChange={(e) => setFormData({ ...formData, latitude: e.target.value })}
              />
              <TextField
                margin="dense"
                label="Longitude *"
                fullWidth
                value={formData.longitude}
                error={!!formErrors.longitude}
                helperText={formErrors.longitude}
                onChange={(e) => setFormData({ ...formData, longitude: e.target.value })}
              />
            </Box>

            <TextField
              margin="dense"
              label="Address *"
              fullWidth
              multiline
              rows={2}
              value={formData.address}
              error={!!formErrors.address}
              helperText={formErrors.address}
              onChange={(e) => setFormData({ ...formData, address: e.target.value })}
            />

            <TextField
              margin="dense"
              label="Details"
              fullWidth
              multiline
              rows={3}
              value={formData.details}
              onChange={(e) => setFormData({ ...formData, details: e.target.value })}
            />

            <TextField
              margin="dense"
              label="Contact"
              fullWidth
              value={formData.contact}
              onChange={(e) => setFormData({ ...formData, contact: e.target.value })}
            />

            {/* Photos Upload */}
            <Box>
              <Typography variant="subtitle2" sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                <Photo sx={{ mr: 1 }} /> 
                {isEditMode ? 'Add New Photos' : 'Photos'} (Max 10, 5MB each)
                {isEditMode && <Typography variant="caption" sx={{ ml: 2, color: 'text.secondary' }}>
                  (Will be added to existing photos)
                </Typography>}
              </Typography>
              <input
                accept="image/*"
                style={{ display: 'block', marginTop: '8px' }}
                id="photos-upload"
                type="file"
                multiple
                ref={photoInputRef}
                onChange={handlePhotoChange}
              />
              <Typography variant="caption" sx={{ display: 'block', mt: 0.5, color: 'text.secondary' }}>
                Hold Ctrl (Cmd on Mac) to select multiple files
              </Typography>
              {formErrors.photos && (
                <FormHelperText error>{formErrors.photos}</FormHelperText>
              )}
              {photos.length > 0 && (
                <Box sx={{ mt: 1 }}>
                  {photos.map((file, i) => (
                    <Chip 
                      key={i} 
                      label={file.name} 
                      size="small" 
                      color="success" 
                      sx={{ mr: 1, mb: 1 }} 
                      onDelete={() => {
                        const newPhotos = [...photos];
                        newPhotos.splice(i, 1);
                        setPhotos(newPhotos);
                      }}
                    />
                  ))}
                </Box>
              )}
            </Box>

            {/* Documents Upload */}
            <Box>
              <Typography variant="subtitle2" sx={{ mb: 1, display: 'flex', alignItems: 'center' }}>
                <Description sx={{ mr: 1 }} /> 
                {isEditMode ? 'Add New Documents' : 'Documents'} (Max 5, 5MB each)
                {isEditMode && <Typography variant="caption" sx={{ ml: 2, color: 'text.secondary' }}>
                  (Will be added to existing documents)
                </Typography>}
              </Typography>
              <input
                accept=".pdf,.doc,.docx,.xls,.xlsx"
                style={{ display: 'block', marginTop: '8px' }}
                id="documents-upload"
                type="file"
                multiple
                ref={documentInputRef}
                onChange={handleDocumentChange}
              />
              <Typography variant="caption" sx={{ display: 'block', mt: 0.5, color: 'text.secondary' }}>
                Hold Ctrl (Cmd on Mac) to select multiple files
              </Typography>
              {formErrors.documents && (
                <FormHelperText error>{formErrors.documents}</FormHelperText>
              )}
              {documents.length > 0 && (
                <Box sx={{ mt: 1 }}>
                  {documents.map((file, i) => (
                    <Chip 
                      key={i} 
                      label={file.name} 
                      size="small" 
                      color="info" 
                      sx={{ mr: 1, mb: 1 }} 
                      onDelete={() => {
                        const newDocs = [...documents];
                        newDocs.splice(i, 1);
                        setDocuments(newDocs);
                      }}
                    />
                  ))}
                </Box>
              )}
            </Box>
          </Box>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenFormDialog(false)} disabled={submitLoading}>
            Cancel
          </Button>
          <Button onClick={handleFormSubmit} variant="contained" color="primary" disabled={submitLoading}>
            {submitLoading ? <LoadingSpinner size={20} /> : (isEditMode ? 'Update' : 'Add')}
          </Button>
        </DialogActions>
      </Dialog>

      {/* Delete Confirmation Dialog */}
      <Dialog open={deleteDialogOpen} onClose={() => setDeleteDialogOpen(false)}>
        <DialogTitle>Confirm Delete</DialogTitle>
        <DialogContent>
          Are you sure you want to delete "{deleteProperty?.name}" ({deleteProperty?.status})?
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteDialogOpen(false)} disabled={submitLoading}>
            Cancel
          </Button>
          <Button onClick={handleDelete} variant="contained" color="error">
            Delete
          </Button>
        </DialogActions>
      </Dialog>

      <SnackBarComponent
        open={snackbarOpen}
        message={snackbarMessage}
        severity={snackbarSeverity}
        onClose={handleSnackbarClose}
      />
    </Box>
  );
};

export default AdminPropertyComponent;